type IconProps = { class?: string };

const svgProps = (size: number, props: IconProps) => ({
  class: props.class || '',
  width: String(size),
  height: String(size),
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
});

export const IconBack = (props: IconProps) => (
  <svg {...svgProps(16, props)} viewBox="0 0 16 16">
    <path d="M10 3L5 8l5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

export const IconChevronRight = (props: IconProps) => (
  <svg {...svgProps(16, props)} viewBox="0 0 16 16">
    <path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

export const IconChevronDown = (props: IconProps) => (
  <svg {...svgProps(16, props)} viewBox="0 0 16 16">
    <path d="M3 6l5 5 5-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

export const IconBank = (props: IconProps) => (
  <svg {...svgProps(24, props)}>
    <path d="M4 10h16M6 10v7M10 10v7M14 10v7M18 10v7M3 19h18M12 4l9 5H3l9-5z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
  </svg>
);

export const IconCopy = (props: IconProps) => (
  <svg {...svgProps(16, props)} viewBox="0 0 16 16">
    <rect x="5.5" y="5.5" width="8" height="8" rx="1.5" stroke="currentColor" stroke-width="1.4" />
    <path d="M10.5 5.5V3.8A1.3 1.3 0 0 0 9.2 2.5H3.8A1.3 1.3 0 0 0 2.5 3.8v5.4A1.3 1.3 0 0 0 3.8 10.5H5.5" stroke="currentColor" stroke-width="1.4" />
  </svg>
);

export const IconCloseCircle = (props: IconProps) => (
  <svg {...svgProps(16, props)} viewBox="0 0 16 16">
    <circle cx="8" cy="8" r="6.2" stroke="currentColor" stroke-width="1.4" />
    <path d="M6 6l4 4M10 6L6 10" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
  </svg>
);

export const IconClose = (props: IconProps) => (
  <svg {...svgProps(20, props)} viewBox="0 0 20 20">
    <path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
  </svg>
);

/** 上传加号：跟随父级 color（暗黑下 --text 为 #fff） */
export const IconUploadPlus = (props: IconProps) => (
  <svg {...svgProps(14, props)} viewBox="0 0 14 14" aria-hidden="true">
    <path
      d="M7 2V12"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2 7H12"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
